import { Component, OnInit } from '@angular/core';
import { User } from '../../../model/user';
import { UsuarioService } from './usuario.service';
import { NgForm } from '@angular/forms';
import { NotificationService } from '../../../notification/notification.service';

@Component({
  selector: 'app-usuario',
  templateUrl: './usuario.component.html',
  styleUrls: ['./usuario.component.css']
})
export class UsuarioComponent implements OnInit {

  user: User;

  listaUsuarios;
  private novoUser: User;
  usuarioForm: NgForm;
  login: string;

  constructor(private usuarioService: UsuarioService,
    private notificationService: NotificationService) {
    this.user = new User();
  }

  ngOnInit(){
    this.getUser();
  }

  getValue() {
    let nome = JSON.parse(this.user.nome).split('');
  }

  onSubmit() {
    this.usuarioService.cadastrar(this.user)
    .subscribe(
      res => {
        this.getUser();
        this.notificationService.info(
          "Usuario cadastrado com sucesso!"
        ); 
      },
        error => {
          this.notificationService.error(
            "Opa! Verifique se preencheu os campos corretamente e tente novamente."
          );     
        }
    );
 }

 getUser() {
  this.usuarioService.listarUsuarios()
    .subscribe(
      data => {
        this.listaUsuarios = data;
      }
    )
}

deletar(id) {
  this.usuarioService.deletar(id)
    .subscribe(res => {
      this.novoUser = res;
      this.getUser(); 
    });
}


}



// WEBPACK FOOTER //
// ./src/app/gerenciador/dashboard/usuario/usuario.component.ts